<a [routerLink]="['/', post.slug]"
   class="block w-full h-[340px] rounded-[36px] text-white overflow-hidden shadow-lg cursor-pointer hover:opacity-90 transition-opacity"
   style="border-color: rgba(255, 255, 255, 0.3); background: linear-gradient(to bottom right, rgba(0,0,0,0), rgba(0,0,0,0.7));">
  <div class="relative h-[190px] rounded-[36px] overflow-hidden bg-gradient-to-br from-black/80 via-black/70 to-black/60">
    @if (post.featured_image) {
      <img [src]="post.featured_image"
           [alt]="post.featured_image_alt || post.title"
           loading="lazy"
           class="absolute inset-0 w-full h-full object-cover" />
    }
    <div class="absolute bottom-2 left-6 font-outfit bg-black/60 px-2 py-1 rounded text-xs z-10">
      {{ categoryLabel }}
    </div>
  </div>

  <div class="font-inter pt-[16px] pb-[12px] px-4 text-justify text-sm line-clamp-3">
    {{ post.title }}
  </div>
  <div class="font-inter px-4 text-xs text-white/60">
    {{ formattedDate }}
  </div>
</a>
